module.exports = __webpack_public_path__ + "img/hearts.27e5c670.png";